/**
 * Places childOrb.group inside parentOrb.group according to containment style.
 * - "concentric": child is centered; smaller radius.
 * - "packed": children distributed around inside but still within parent radius.
 * - "planes": children stacked in Y like block scopes / code scopes.
 * - "rectStack": (future rectangular containment)
 */
export function positionChildInsideParentVolume(opts) {
    const { parentOrb, childOrb, layoutMode, spec, indexInSiblings, depth } = opts;
    if (!parentOrb.group || !childOrb.group)
        return;
    const parentR = parentOrb.getEffectiveRadius();
    const childR = childOrb.getEffectiveRadius();
    switch (layoutMode) {
        case 'concentric': {
            // every child goes at center, maybe tiny Z offset so you can see shells
            childOrb.group.position.set(0, (depth === 0 ? 0 : depth * (childR * 0.1)), 0);
            break;
        }
        case 'packed': {
            // radial ring distribution based on sibling index
            const angle = (indexInSiblings / 6) * Math.PI * 2; // 6 is arbitrary ring size
            const ringRadius = Math.max(0, parentR * 0.4 - childR * 1.1);
            const x = ringRadius * Math.cos(angle);
            const z = ringRadius * Math.sin(angle);
            const y = depth * (childR * 0.5);
            childOrb.group.position.set(x, y, z);
            break;
        }
        case 'planes': {
            // stack vertically like nested scopes, x/z fan out just a bit
            const y = -depth * (childR * 2.2);
            const x = (indexInSiblings - 2) * (childR * 1.2);
            const z = 0;
            childOrb.group.position.set(x, y, z);
            break;
        }
        case 'rectStack': {
            // placeholder for rectangular container worlds; not used in spheres yet
            childOrb.group.position.set((indexInSiblings - 2) * (childR * 1.2), -depth * (childR * 2.2), 0);
            break;
        }
        default: {
            // custom/manual
            if (spec.placement === 'custom' && spec.offset) {
                childOrb.group.position.copy(spec.offset);
            }
            else {
                childOrb.group.position.set(0, 0, 0);
            }
            break;
        }
    }
}
